import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { skipToken } from "@reduxjs/toolkit/query";
import { ChangeEvent, FormEvent, useCallback, useState } from "react";
import { useGetPricesByProductQuery } from "src/api/services/productsApi";
import { PatientSubscriptions } from "src/api/types";
import LoadingButton from "src/components/Buttons/LoadingButton/LoadingButton";
import { Close } from "@mui/icons-material";
import { desktopSx } from "src/utils/styles/modalStyles";
import { Alert } from "@mui/material";
import { useChangePlanMutation } from "src/api/services/subscriptionsApi";

interface Props {
  subscription: PatientSubscriptions;
  onClose: () => void;
  open: boolean;
}

const ChangeSubscriptionModal = ({ subscription, onClose, open }: Props) => {
  const [error, setError] = useState("");
  // const [createPrescription, setCreatePrescription] = useState(false);
  const [priceId, setPriceId] = useState<number | null>(null);

  const { data: prices = [] } = useGetPricesByProductQuery(
    subscription.product.slug
      ? {
          slug: subscription.product.slug,
          active: true,
        }
      : skipToken
  );
  const [changePlan, { isLoading }] = useChangePlanMutation();

  // const handlePrescription = useCallback(
  //   (event: ChangeEvent<HTMLInputElement>) => {
  //     setCreatePrescription(event.target.checked);
  //   },
  //   []
  // );

  const handlePrice = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setPriceId(Number(event.target.value));
  }, []);

  const handleSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      if (priceId == null) {
        setError("Please select price");
        return;
      }

      setError("");
      changePlan({
        id: subscription.id,
        priceId,
        patient_id: subscription.patient_id,
      })
        .unwrap()
        .then(() => {
          onClose();
          setPriceId(null);
        })
        .catch((err) => {
          setError(err.data.message);
        });
    },
    [changePlan, onClose, priceId, subscription.id, subscription.patient_id]
  );

  return (
    <Modal open={open}>
      <Stack sx={desktopSx} gap={2}>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight={700} variant="h5">
            Change Plan
          </Typography>
          <IconButton onClick={onClose}>
            <Close fontSize="medium" />
          </IconButton>
        </Stack>
        <Alert severity="warning">
          You can only change plan within the same product
        </Alert>
        <Stack
          gap={2}
          component="form"
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <FormControl>
            <TextField
              disabled
              label="Product"
              value={subscription.product.name}
            />
          </FormControl>

          <Stack>
            <TextField
              select
              label="Price"
              value={priceId ?? ""}
              onChange={handlePrice}
              required
            >
              {prices
                .filter((price) => price.id != subscription.price_id)
                .map((price) => (
                  <MenuItem key={price.id} value={price.id}>
                    {price.name}
                  </MenuItem>
                ))}
            </TextField>
            {/* <FormControl error={createPrescription}>
              <FormControlLabel
                checked={createPrescription}
                control={<Checkbox onChange={handlePrescription} />}
                label="Create prescription"
              />
              {createPrescription ? (
                <FormHelperText sx={{ margin: 0 }}>
                  This will create new prescription request and prescription
                  request task
                </FormHelperText>
              ) : null}
            </FormControl> */}
          </Stack>
          <Stack gap={1}>
            {error ? (
              <Typography sx={{ color: "red" }} textAlign="center">
                {error}
              </Typography>
            ) : null}

            <LoadingButton loading={isLoading} type="submit">
              Change Plan
            </LoadingButton>
          </Stack>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default ChangeSubscriptionModal;
